module.exports = "\r\n\r\n<h1>Welcome to the SAMPLE section!</h1>"


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/sample/containers/welcome-page/welcome-page.html
// module id = ../../../../../src/app/sample/containers/welcome-page/welcome-page.html
// module chunks = main